import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TimeSlot } from '@checkout-v2/const';
import { TodayTomorrowDatePipe } from '@sdvor/shared/ui/v2';

@Component({
  selector: 'sd-time-slot-date-item',
  imports: [TodayTomorrowDatePipe, DatePipe],
  templateUrl: './time-slot-date-item.component.html',
  styleUrl: './time-slot-date-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotDateItemComponent {
  readonly timeSlot = input.required<TimeSlot>();

  protected readonly cheapestOption = computed(() => {
    const timeSlot = this.timeSlot();
    const cheapestOptionId = timeSlot.cheapestOptionId;

    for (const group of timeSlot.groups) {
      const found = group.options.find((option) => option.id === cheapestOptionId);

      if (found) {
        return found;
      }
    }

    return undefined;
  });
}
